import { render, staticRenderFns } from "./RecepToSenderDialog.vue?vue&type=template&id=0b9fafed&"
import script from "./RecepToSenderDialog.vue?vue&type=script&lang=js&"
export * from "./RecepToSenderDialog.vue?vue&type=script&lang=js&"
import style0 from "./RecepToSenderDialog.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QField});
